// GCO Styles components

jQuery(function() {
  // Hamburger animation and open responsive nav
  var hamburger = jQuery('#hamburger-icon');

  jQuery(hamburger).click(function(){
    jQuery("body").addClass('show-nav');
    hamburger.addClass('active');
    return false;
  });

  // Close responsive nav
  jQuery(document).on("click", ".show-nav .main", function(){
    jQuery("body").removeClass('show-nav');
    hamburger.removeClass('active');
    return false;
  });

  // Switch group in header
  jQuery("#switch-group").on("select2:select", function (e) {
      window.location.href=this.value
  });

  // Blocks collapse/expand
  jQuery('.block--collapsible h2').click(function(){
    jQuery(this).toggleClass('is-open');
    jQuery(this).closest('.block--collapsible').toggleClass('is-open');
    jQuery(this).next('.block__content').toggleClass('block--is-open');
  });

  // Modal opening
  jQuery('.modal__open').click(function(){
    jQuery('.modal').modal('setting', 'closable', false).modal('show');
    return false;
  });

  jQuery('.modal__open--full-screen').click(function(){
    jQuery('.fullscreen.modal').modal('setting', 'closable', false).modal('show');
    return false;
  });

  // Modal closing
  jQuery('.modal__close').click(function(){
    jQuery(this).parents('.modal').modal('hide');
    return false;
  });

  // Tooltips
  jQuery('.tooltip').popup({
    inline: false,
    hoverable: true,
    position: 'bottom center',
    delay: {
      show: 50,
      hide: 200
    }
  });

  // Tooltips with click for trigger
  jQuery('.tooltip--click').popup({
    hoverable: true,
    on: 'click',
    position: 'bottom center'
  });

  // Tab bar
  jQuery(".tab__container").easytabs({
    animate: false,
    updateHash: false
  });

  // Close icon for alerts
  jQuery('.close').click(function() {
    jQuery(this).closest('.alert').hide();
  });

  // Default data tables tables
  jQuery('.data-table').DataTable({
    paging:         false,
    autowidth:      true,
    "order": [], // Removes default sorting so Rails can handle it
    "columnDefs": [
      { "searchable": false, "targets": "no-search" },
      { "bSortable": false, "targets": "no-sort" }
    ],
    language: {
      search: "_INPUT_",
      searchPlaceholder: "Filter..."
    }
  });

  // Select and search component
  jQuery('.select-and-search').select2({
    placeholder: "Please select...",
    allowClear: true
  });

  // Select and search, allows tags
  jQuery(".select-and-search--allows-tags").select2({
    tags: true,
    allowClear: true,
    placeholder: "Please select..."
  });

  // Live search through cards
  jQuery('.live-search-target').each(function(){
    jQuery(this).attr('data-search-term', jQuery(this).text().toLowerCase());
  });

  jQuery('.live-search-box').on('keyup', function(){
    var searchTerm = jQuery(this).val().toLowerCase();
    jQuery('.live-search-target').each(function(){
      if (jQuery(this).filter('[data-search-term *= ' + searchTerm + ']').length > 0 || searchTerm.length < 1) {
        jQuery(this).closest('.card, li').show();
      } else {
        jQuery(this).closest('.card, li').hide();
      }
    });
  });

  // Filter component
  jQuery('.filter__label').click(function() {
    jQuery(this).closest('.filter').toggleClass('filter--is-open');
    return false;
  });
});
